import { Calendar as CalendarComponent, CalendarProps } from "@/components/ui/calendar"
import { PlainDate } from "@/utils/date"

import { parse, format } from "date-fns"
const option =
	<T extends any>(value: T | undefined) =>
	<Result extends any>(f: (x: T) => Result): Result | undefined =>
		typeof value == "undefined" ? undefined : f(value)

interface DateCalendarProps extends Omit<CalendarProps, "selected" | "onSelect"> {
	value?: { from?: PlainDate; to?: PlainDate }
	onChange: (value: { from?: PlainDate; to?: PlainDate }) => void
}

const parseDate = (date: PlainDate) => {
	return parse(date.date, "yyyy-MM-dd", new Date())
}

const formatDate = (date: Date) => {
	return format(date, "yyyy-MM-dd")
}

/**
 * A wrapper around the Calendar component that works with plain date format
 * @param value plain date format
 * @returns plain date format
 * @example "2025-02-01"
 */
export const RangeCalendarWrapper: React.FC<DateCalendarProps> = ({
	value,
	onChange,
	...props
}) => {
	return (
		<CalendarComponent
			{...props}
			numberOfMonths={2}
			mode="range"
			selected={{
				from: option(value?.from)(parseDate),
				to: option(value?.to)(parseDate),
			}}
			onSelect={(range) => {
				onChange({
					from: option(range?.from)((x) => PlainDate.from(formatDate(x))),
					to: option(range?.to)((x) => PlainDate.from(formatDate(x))),
				})
			}}
		/>
	)
}
